export type InstallChoice = 'accepted' | 'dismissed'

export type DeferredInstallPrompt = Event & {
  prompt: () => Promise<void>
  userChoice: Promise<{ outcome: InstallChoice; platform: string }>
}

export function isDeferredInstallPrompt(event: Event): event is DeferredInstallPrompt {
  const candidate = event as Partial<DeferredInstallPrompt>
  return typeof candidate.prompt === 'function' && candidate.userChoice instanceof Promise
}

export async function requestDeferredInstall(event: DeferredInstallPrompt): Promise<InstallChoice> {
  await event.prompt()
  return (await event.userChoice).outcome
}
